import React from 'react';
import { SlArrowUp, SlArrowDown } from 'react-icons/sl';
import styles from './ArrowUpDown.module.scss';

type ArrowUpDownProps = {
  isExpanded: boolean | undefined;
};

export const ArrowUpDown = ({ isExpanded }: ArrowUpDownProps) => {
  return isExpanded ? (
    <SlArrowUp data-testid="SlArrowUp" className={styles.iconActive} />
  ) : (
    <SlArrowDown data-testid="SlArrowDown" className={styles.icon} />
  );
};
